"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeaderText = exports.StyledHeaderLabel = exports.StyledHeaderElement = exports.StyledHeaderContainer = exports.getBackgroundColorForHeaderElement = void 0;
// styles
const Theme_1 = require("../../Theme/Theme");
const getBackgroundColorForHeaderElement = (props) => props.isActive ? props.theme.colors.gray[20] : props.theme.white;
exports.getBackgroundColorForHeaderElement = getBackgroundColorForHeaderElement;
exports.StyledHeaderContainer = Theme_1.styled.div `
  border: 1px;
  margin: 0 auto;
`;
exports.StyledHeaderElement = Theme_1.styled.div `
  border-radius: 5px 5px 0px 0px;
  box-shadow: 0px 2px 1px -1px gray;
  width: 616px;
  height: 48px;
  display: flex;
  background: ${(props) => (0, exports.getBackgroundColorForHeaderElement)(props)};
`;
exports.StyledHeaderLabel = Theme_1.styled.div `
  vertical-align: middle;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  padding-top: ${(props) => props.paddingTop}px;
  padding-bottom: ${(props) => props.paddingBottom}px;
  padding-left: ${(props) => props.paddingLeft}px;
  padding-right: ${(props) => props.paddingRight}px;
  flex: auto;
`;
exports.StyledHeaderText = Theme_1.styled.p `
  display: block;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  margin-block-start: 0em;
  margin-block-end: 0em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.isDisabled
    ? props.theme.colors.gray[50]
    : props.theme.colors.gray[90]};
  font-size: 16px;
  font-family: proxima-nova;
`;
//# sourceMappingURL=DropdownHeader.styles.js.map